import React from 'react';
import {
  BsAirplane, BsWater, BsSignpost,
} from 'react-icons/bs';
import {
  HiLightningBolt, HiCube, HiTruck,
} from 'react-icons/hi';
import useScrollReveal from '../hooks/useScrollReveal';

const infraProjects = [
  { icon: <BsAirplane className="text-2xl" />, title: 'Navi Mumbai International Airport', detail: 'Mega airport project driving massive real estate demand in the entire region', featured: true },
  { icon: <BsWater className="text-xl" />, title: 'Mumbai Trans Harbour Link', detail: "21.8 km sea bridge — India's longest", featured: false },
  { icon: <BsSignpost className="text-xl" />, title: 'Virar-Alibaug Multimodal Corridor', detail: '126 km expressway connecting northern Mumbai to Konkan coast', featured: false },
  { icon: <HiCube className="text-xl" />, title: 'JNPT – Chauk Greenfield Corridor', detail: 'New freight corridor boosting industrial connectivity', featured: false },
  { icon: <HiTruck className="text-xl" />, title: 'Local Train Network', detail: 'Extended suburban railway connecting MahaMumbai', featured: false },
  { icon: <HiLightningBolt className="text-xl" />, title: 'Metro Expansion', detail: 'Multiple new metro lines enhancing urban mobility', featured: false },
  { icon: <BsWater className="text-xl" />, title: 'Water Taxi', detail: 'Waterway transport connecting key coastal nodes', featured: false },
];

const Amenities = () => {
  const [headRef, headVisible] = useScrollReveal();
  const [gridRef, gridVisible] = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="infrastructure" className="py-24 lg:py-32 bg-white overflow-hidden relative border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header — centered */}
        <div ref={headRef} className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-[11px] tracking-[0.3em] uppercase font-semibold text-accent-500 mb-5">
            $30 Billion Boom
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-dark-800 leading-tight mb-5">
            Infrastructure{' '}
            <span className="italic text-primary-600">Projects</span>
          </h2>
          <p className="text-dark-400 text-base leading-relaxed font-light">
            Massive government-backed projects transforming MahaMumbai into India's next mega growth corridor.
          </p>
        </div>

        {/* Bento Grid */}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {infraProjects.map((project, i) => (
            <div
              key={i}
              className={`group rounded-2xl border transition-all duration-700 cursor-default ${
                project.featured
                  ? 'sm:col-span-2 lg:col-span-2 bg-primary-600 border-primary-600 text-white p-8 lg:p-10'
                  : 'bg-white border-gray-100 hover:border-primary-200 hover:shadow-lg p-6 lg:p-7'
              } ${
                gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: gridVisible ? `${i * 80}ms` : '0ms' }}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-all duration-500 ${
                project.featured
                  ? 'bg-white/15 text-white'
                  : 'bg-primary-50 text-primary-600 group-hover:bg-primary-600 group-hover:text-white'
              }`}>
                {project.icon}
              </div>
              <h3 className={`font-heading text-lg mb-2 leading-snug ${
                project.featured ? 'text-white text-xl lg:text-2xl' : 'text-dark-800 group-hover:text-primary-700 transition-colors duration-500'
              }`}>
                {project.title}
              </h3>
              <p className={`text-[13px] leading-relaxed font-light ${
                project.featured ? 'text-white/60 max-w-md' : 'text-dark-400'
              }`}>
                {project.detail}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <button onClick={() => window.dispatchEvent(new Event('openContactModal'))} className="inline-flex items-center gap-2 border-2 border-dark-700 text-dark-700 rounded-full px-8 py-3 text-[11px] font-semibold tracking-wider uppercase hover:bg-dark-700 hover:text-white transition-all duration-500 group">
            Enquire About Projects
            <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Amenities;
